import { useFeatureFlags } from '@funtech-int/yango-shared';

import { QueryParameter } from '@/shared/constants/queryParams';
import { useSearchParams } from '@/shared/hooks/useSearchParams';

export function useYaPlayerVersion(): string | undefined {
    const searchParams = useSearchParams();
    const playerVersionQueryParam = searchParams.get(QueryParameter.PLAYER_VERSION);

    const playerVersionFromQueryParam =
        typeof playerVersionQueryParam === 'string' ? playerVersionQueryParam : undefined;
    const featurePlayerVersion = useFeatureFlags().flags.get('featurePlayerVersion', 'string', '');

    if (playerVersionFromQueryParam) {
        return playerVersionFromQueryParam;
    }

    if (typeof featurePlayerVersion === 'string' && featurePlayerVersion.length > 0) {
        return featurePlayerVersion;
    }

    return undefined;
}
